import { render, staticRenderFns } from "./demandaRegionalizada.vue?vue&type=template&id=265de6a3&scoped=true&"
import script from "./demandaRegionalizada.vue?vue&type=script&lang=js&"
export * from "./demandaRegionalizada.vue?vue&type=script&lang=js&"
import style0 from "./demandaRegionalizada.vue?vue&type=style&index=0&id=265de6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265de6a3",
  null
  
)

export default component.exports